import { render, staticRenderFns } from "./StaticReport.vue?vue&type=template&id=3b4712ec&scoped=true"
import script from "./StaticReport.vue?vue&type=script&lang=js"
export * from "./StaticReport.vue?vue&type=script&lang=js"
import style0 from "./StaticReport.vue?vue&type=style&index=0&id=3b4712ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4712ec",
  null
  
)

export default component.exports